export {
  useGetOfferRecommendations,
  useSaveOfferDisposition,
} from './useCeOffers';
